import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsConfigKey } from '@core/enums/app-setting-config-key.enum';
import { AppSettings } from '@core/models/settings/app-settings.model';
import { BehaviorSubject, lastValueFrom, of } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  private config: AppSettings;
  private appSettingsFileName = AppSettingsConfigKey.FileName;
  private appSettingsPath = AppSettingsConfigKey.Path;
  public appSettings = new BehaviorSubject<AppSettings>({} as AppSettings);
  public appSettings$ = this.appSettings;

  constructor(private httpClient: HttpClient) { }

  public async initApplicationSettings(): Promise<any> {
    return lastValueFrom(
      this.httpClient
        .get<AppSettings>(this.appSettingsPath + '/' + this.appSettingsFileName)
        .pipe(
          mergeMap((config00) => {
            return this.httpClient
              .get<AppSettings>(config00.configurationUrl)
              .pipe(
                mergeMap((config01) => {
                  return of({ ...config00, ...config01 });
                }),
                catchError(() => {
                  return of(config00);
                })
              );
          }),
          tap(async (mergedConfig) => {
            if (environment.mock) {
              mergedConfig.b2cSettings.LogoutUrl.replace('https', 'http');
              mergedConfig.b2cSettings.RedirectUrl.replace('https', 'http');
            }
            this.config = mergedConfig;
            this.appSettings.next(this.config);
          }),
          mergeMap(() => {
            return of(this.config);
          })
        )
    );
  }

  public get configuration(): AppSettings {
    return this.config;
  }
}
